import { render, staticRenderFns } from "./RangeSettings.vue?vue&type=template&id=c9478ad4&"
import script from "./RangeSettings.vue?vue&type=script&lang=ts&"
export * from "./RangeSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports